import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { Router } from '@angular/router';
import { MappingService } from 'src/app/services/mapping.service';
import { CurriculumStore } from 'src/app/stores/resources/curriculum.store';
import { ResourceStore } from 'src/app/stores/resources/resource.store';

@Component({
  selector: 'app-add-program-level-lesson-module',
  templateUrl: './add-program-level-lesson-module.component.html',
  styleUrls: ['./add-program-level-lesson-module.component.scss']
})
export class AddProgramLevelLessonModuleComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Add module to program"

  form: FormGroup;
  module: AbstractControl;

  MODULE_LIST: any;
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  MODULE_LIST_DATA=[]

  PROGRAM_MODULE: any[] = [];
  constructor(
    public dialogRef: MatDialogRef<AddProgramLevelLessonModuleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: CurriculumStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private resource: ResourceStore,
    private route: Router,
  ) { }

  async ngOnInit() {
    const { MODULE } = this.data;
    this.form = this.fb.group({
      module: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
    })
    this.module = this.form.controls['module'];
    if (MODULE) {
      this.TITLE = "Edit module to program";
    }
    const { data } = this.store;
    this.MODULE_LIST_DATA = await this.resource.fetchListArray(COLLECTION_NAME.MODULE, "name");
    if (data && data.moduleKey) {
      this.MODULE_LIST_DATA = this.MODULE_LIST_DATA.filter(m => !data.moduleKey.includes(m.key));
    }
    this.MODULE_LIST = MappingService.autoComplete(this.module, this.MODULE_LIST_DATA, "name");

  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.form.disable();
      const { PROGRAM_KEY, LEVEL_KEY, LESSON_KEY } = this.data;
      const { user } = this.auth;
      this.error = null;
      this.isCreate = true;
      const { module } = f;
      this.store.addModule(module, LESSON_KEY, LEVEL_KEY, PROGRAM_KEY, user.uid, (success, res) => {
        if (success) {
          this.snackBar.open("Module and activities have been added to program successful.", "Done", { duration: 2500 });
        }
        this.MODULE_LIST_DATA = this.MODULE_LIST_DATA.filter(m =>m && m.key !== module.key)
        this.MODULE_LIST = MappingService.autoComplete(this.module, this.MODULE_LIST_DATA, "name");
        this.form.enable();
        this.form.reset();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (!isNew) {
          this.dialogRef.close();
        }
      })
    }
  }
}